import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

import './SrSunSetupDriverJobPage.less';

const SrSunSetupDriverJobSunlockCodes = ({
  sunlock,
}) => {
  return (
    <div styleName='card' className='fieldsContainer'>
      <span styleName='cardTitle'>
        Program Sunlock
      </span>

      <SrBox margin='16px 0 0'>
        <div styleName='sunlockBox'>
          <span styleName='codeTitle'>Master Code</span>
          <br />
          <span styleName={sunlock ? 'codeValue' : 'serialNumber'}>
            {sunlock?.partnerLockCode || 'Register the Sunlock to show'}
          </span>
        </div>
      </SrBox>

      <SrBox margin='16px 0 0'>
        <div styleName='sunlockBox'>
          <span styleName='codeTitle'>Guest Code</span>
          <br />
          <span styleName={sunlock ? 'codeValue' : 'serialNumber'}>
            {sunlock?.lockCode || 'Register the Sunlock to show'}
          </span>
        </div>
      </SrBox>

      <SrBox margin='16px 0 0'>
        <SrText
          font='greycliff'
          size='16'
          weight='600'
          paddingTop='16px'
        >
          You must first register the Sunlock above to generate the lock codes.
          Press the program button, enter the code, and then press the lock button to program a code.
        </SrText>
      </SrBox>
    </div>
  );
};

SrSunSetupDriverJobSunlockCodes.propTypes = {
  sunlock: PropTypes.object,
};

SrSunSetupDriverJobSunlockCodes.displayName = 'SrSunSetupDriverJobSunlockCodes';

export default SrSunSetupDriverJobSunlockCodes;
